var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719794590949,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2123,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M853.344 341.344C853.344 294.4 814.944 256 768 256s-85.344 38.4-85.344 85.344 38.4 85.344 85.344 85.344 85.344-38.4 85.344-85.344z",
    "p-id": 2124,
    fill: "#8a8a8a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 85.344v853.344h512v-85.344H85.344V742.4l256-256L512 657.056l59.744-59.744-230.4-230.4-256 256V170.656h853.344v256L1024.032 512V85.344z",
    "p-id": 2125,
    fill: "#8a8a8a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M951.456 755.2l59.744-59.744-200.544-200.544-200.544 200.544 59.744 59.744L768 657.056v196.256h85.344v-196.256zM597.344 938.656h85.344V1024h-85.344v-85.344zM768 938.656h85.344V1024H768v-85.344zM938.656 938.656H1024V1024h-85.344v-85.344z",
    "p-id": 2126,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchUploadImg);
export default __webpack_public_path__ + "static/media/batch_upload_img.29c78691ed8379d5f7642bc6b6b88798.svg";
export { ForwardRef as ReactComponent };